import {useSpring} from 'react-spring'
import useImage from 'use-image'
import flames from './fire_1.png'
import {Group, Image} from 'react-konva'
import React from 'react'
import {lerp, register} from '../utils'
import {getState} from '../game-surface'

export const flicker = register('flicker', {
    initialize() {
        this.flameScaleX = 1
        this.flameScaleY = 1

    },
    postInitialize() {
        this.$.transform.Sprite = Flames.bind(this)
    },
    methods: {
        Update(dt) {
            const props = useSpring({
                scaleX: Math.random(),
                scaleY: Math.random() * 3.4,
                offsetY: Math.random() * 30,
                rotate: Math.random() * 30 - 15,
                config: {mass: 3, tension: 250, friction: 30},
            })
            this.flameScaleX = 1 - props.scaleX.getValue() / 8
            this.flameScaleY = props.scaleY.getValue()
        },
    },
})

function Flames() {
    let [image] = useImage(flames)
    if (!image) return null
    let scaleY = lerp(0.1 * this.flameScaleY, this.flameScaleY, getState().height / 100)
    return (
        <Group y={320} scaleX={this.flameScaleX} scaleY={scaleY}>
            <Image
                opacity={0.9}
                x={-image.width / 2}
                y={0}
                // scaleX={0.6} scaleY={0.6}
                image={image}
            />
        </Group>
    )
}
